"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallHangupByEnum = void 0;
var VoiceCallHangupByEnum;
(function (VoiceCallHangupByEnum) {
    VoiceCallHangupByEnum["Agent"] = "AGENT";
    VoiceCallHangupByEnum["Contact"] = "CONTACT";
    VoiceCallHangupByEnum["System"] = "SYSTEM";
})(VoiceCallHangupByEnum = exports.VoiceCallHangupByEnum || (exports.VoiceCallHangupByEnum = {}));
